import { NavLinkMenu } from './NavLinkMenu';

export function QuickLinksMenu() {
  const linkIcon = (
    <svg
      className="w-5 h-5"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m9.968-3.21a4.5 4.5 0 00-1.242-7.244l-4.5-4.5a4.5 4.5 0 00-6.364 6.364L4.34 8.374"
      />
    </svg>
  );

  return (
    <NavLinkMenu
      scope="Tenant"
      icon={linkIcon}
      label="Quick Links"
      emptyMessage="No quick links configured for your organization."
    />
  );
}
